// Printing diagnostics on Printers on this PC (fix of 2 November 2026, "nothing prints"; docs/direct-printing.md,
// "When nothing prints"). Arabic marked "new" needs review by an Arabic copy editor.
export const PRINT_DIAG_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    printerModeEscpos: "ESC/POS raw (optional: ESC/POS receipt printers only)",
    printerModeDriver: "Windows driver (recommended: any printer that prints a Windows test page)",
    printerModeEscposWarn: "ESC/POS sends raw printer commands. A printer that does not understand them accepts the job and prints nothing, and the job still shows as printed. If the Windows test page prints but Delta's test page does not, choose Windows driver.",
    printerModeDriverHint: "Delta draws the receipt and the printer's own Windows driver prints it, like any Windows program. Cutting follows the driver's own settings; Delta does not open the cash drawer in this mode.",
    pdTitle: "Printing diagnostics",
    pdIntro: "What this PC prints with, and why the last prints did or did not come out. Copy it for support; it contains no passwords.",
    pdWhere: "This screen",
    pdWhereApp: "Delta POS for Windows {v} (built-in printing)",
    pdWhereBrowser: "Browser (prints through the Delta Print Agent)",
    pdAgent: "Delta Print Agent on this PC",
    pdAgentNone: "not answering at {url}",
    pdAgentNotPaired: "answering (version {v}), this browser is not paired",
    pdAgentReady: "answering (version {v}), paired",
    pdServer: "Installer on this Delta",
    pdServerNone: "none hosted ({r})",
    pdServerSame: "{v}: this app is up to date",
    pdServerNewer: "{v}: newer than this app ({mine}). Update from Delta POS › Check for updates.",
    pdServerOlder: "{v} (this app is {mine})",
    pdServerOffer: "{v}, SHA-256 {sha}",
    pdBackend: "Printing",
    pdBackend_windows: "Windows printers",
    pdBackend_fake: "test printers (development)",
    pdBackend_none: "no printing on this system",
    pdDiscovery: "Printers Windows lists",
    pdDiscoveryProblem: "could not be listed: {x}",
    pdReceipt: "Receipt printer",
    pdReceiptNone: "not chosen",
    pdReceiptMapped: "{printer} · {mode} · {paper} · copies {copies}",
    pdReceiptMissing: "Windows no longer lists this printer on this PC. Choose it again.",
    pdReceiptState: "Windows reports it as: {s}",
    pdAuto: "Automatic receipt after each sale",
    pdAutoOn: "on",
    pdAutoOff: "off on this PC (Printers on this PC)",
    pdLast: "Last print jobs",
    pdLastNone: "none yet on this PC",
    pdJobLine: "{at} · {doc} · {state}{why}",
    pdCopy: "Copy diagnostics",
    pdCopied: "Diagnostics copied",
    pdHardware: "These checks show what Windows and Delta report. Only paper coming out of the printer shows a printer works; that is checked on site, with the printer itself.",
    pdDoc_invoice: "receipt",
    pdDoc_test: "test page",
    pdDoc_other: "document",
    printReason_driver_print_failed: "the printer's Windows driver did not accept the page",
    printReason_driver_print_cancelled: "printing was cancelled",
    printReason_helper_failed: "the print helper could not start (PowerShell blocked by policy or antivirus?)"
  },
  ar: {
    printerModeEscpos: "ESC/POS مباشر (اختياري: طابعات إيصالات تدعم ESC/POS فقط)", // new
    printerModeDriver: "تعريف ويندوز (موصى به: أي طابعة تطبع صفحة اختبار ويندوز)", // new
    printerModeEscposWarn: "يرسل ESC/POS أوامر طابعة مباشرة. الطابعة التي لا تفهمها تقبل المهمة ولا تطبع شيئًا، وتظهر المهمة كأنها طُبعت. إذا طبعت صفحة اختبار ويندوز ولم تُطبع صفحة اختبار دلتا، فاختر تعريف ويندوز.", // new
    printerModeDriverHint: "يرسم دلتا الإيصال ويطبعه تعريف ويندوز الخاص بالطابعة مثل أي برنامج في ويندوز. القطع يتبع إعدادات التعريف، ولا يفتح دلتا درج النقد في هذا الوضع.", // new
    pdTitle: "تشخيص الطباعة", // new
    pdIntro: "بماذا يطبع هذا الجهاز، ولماذا خرجت آخر الطباعات أو لم تخرج. انسخه للدعم؛ لا يحتوي على كلمات مرور.", // new
    pdWhere: "هذه الشاشة", // new
    pdWhereApp: "دلتا لنقاط البيع لويندوز {v} (طباعة مدمجة)", // new
    pdWhereBrowser: "المتصفح (يطبع عبر وكيل الطباعة من دلتا)", // new
    pdAgent: "وكيل الطباعة على هذا الجهاز", // new
    pdAgentNone: "لا يستجيب على {url}", // new
    pdAgentNotPaired: "يستجيب (الإصدار {v})، وهذا المتصفح غير مربوط", // new
    pdAgentReady: "يستجيب (الإصدار {v})، ومربوط", // new
    pdServer: "المثبّت على دلتا هذه", // new
    pdServerNone: "لا يوجد مثبّت ({r})", // new
    pdServerSame: "{v}: هذا التطبيق محدّث", // new
    pdServerNewer: "{v}: أحدث من هذا التطبيق ({mine}). حدّثه من دلتا لنقاط البيع › البحث عن تحديثات.", // new
    pdServerOlder: "{v} (هذا التطبيق {mine})", // new
    pdServerOffer: "{v}، SHA-256 {sha}", // new
    pdBackend: "الطباعة", // new
    pdBackend_windows: "طابعات ويندوز", // new
    pdBackend_fake: "طابعات اختبار (تطوير)", // new
    pdBackend_none: "لا طباعة على هذا النظام", // new
    pdDiscovery: "الطابعات التي يعرضها ويندوز", // new
    pdDiscoveryProblem: "تعذّر عرضها: {x}", // new
    pdReceipt: "طابعة الإيصالات", // new
    pdReceiptNone: "لم تُختر", // new
    pdReceiptMapped: "{printer} · {mode} · {paper} · النسخ {copies}", // new
    pdReceiptMissing: "لم يعد ويندوز يعرض هذه الطابعة على هذا الجهاز. اخترها مرة أخرى.", // new
    pdReceiptState: "حالتها في ويندوز: {s}", // new
    pdAuto: "الإيصال التلقائي بعد كل بيع", // new
    pdAutoOn: "مفعّل", // new
    pdAutoOff: "متوقف على هذا الجهاز (طابعات هذا الجهاز)", // new
    pdLast: "آخر مهام الطباعة", // new
    pdLastNone: "لا يوجد بعد على هذا الجهاز", // new
    pdJobLine: "{at} · {doc} · {state}{why}", // new
    pdCopy: "نسخ التشخيص", // new
    pdCopied: "نُسخ التشخيص", // new
    pdHardware: "تعرض هذه الفحوص ما يبلّغ به ويندوز ودلتا. وحده خروج الورق من الطابعة يثبت أنها تعمل، ويُفحص ذلك في الموقع مع الطابعة نفسها.", // new
    pdDoc_invoice: "إيصال", // new
    pdDoc_test: "صفحة اختبار", // new
    pdDoc_other: "مستند", // new
    printReason_driver_print_failed: "لم يقبل تعريف ويندوز للطابعة الصفحة", // new
    printReason_driver_print_cancelled: "أُلغيت الطباعة", // new
    printReason_helper_failed: "تعذّر تشغيل مساعد الطباعة (هل يمنع نظام الحماية PowerShell؟)" // new
  }
};
